<template>
  <div
    v-click-outside="hideLevelSelector"
    :class="{
      'cursor-pointer': canChangeLevel,
    }"
    class="flex flex-row items-center relative"
    @click="toggleLevelSelector"
  >
    <div
      :class="{
        'hover:bg-gray-200 px-1.5 duration-300 transition rounded-lg': canChangeLevel,
        'bg-gray-200': dropdownVisibility
      }"
      class="flex-grow  py-2 leading-none select-none"
    >
      <span class="mr-2">
        Level {{ building.level }}<template v-if="levelList.length === 1"> (Max)</template>
      </span>
      <i
        v-if="canChangeLevel"
        :class="{
          'fa-caret-down': !dropdownVisibility,
          'fa-caret-up': dropdownVisibility
        }"
        class="fas"
      />
    </div>
    <div
      v-if="dropdownVisibility"
      class="absolute left-0 flex flex-col top-8 bg-white z-50 rounded-lg w-full border border-roc-blue"
    >
      <div class="max-h-48 overflow-y-auto">
        <template
          v-if="levelList.length > 1"
        >
          <DropdownListItem
            :active="maxLevel === building.level"
            label="Max"
            @click="changeLevel(maxLevel)"
          />
          <template v-if="building.isEvent">
            <DropdownListItem
              :active="20 === building.level"
              label="Level 20"
              @click="changeLevel(20)"
            />
            <DropdownListItem
              :active="30 === building.level"
              label="Level 30"
              @click="changeLevel(30)"
            />
            <DropdownListItem
              :active="40 === building.level"
              label="Level 40"
              @click="changeLevel(40)"
            />
          </template>
          <DropdownListItem
            v-for="level in levelList"
            :key="level"
            :active="level === 'Level ' + building.level"
            :label="level"
            @click="changeLevel(level)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import BuildingType, {isHomeOrFarm} from '@/roc/building/BuildingType';
import BuildingLevel from '@/roc/building/BuildingLevel';
import DropdownListItem from '@/components/Grid/PlacedBuilding/DropdownListItem.vue';
import {computed, ref} from 'vue';
import {useApplicationStore} from '@/roc/stores/ApplicationStore';
import {useLayoutStore} from '@/roc/stores/LayoutStore';

export default {
  components: {DropdownListItem},
  props: {
    buildingId: {
      type: String,
      required: true
    }
  },
  emits: ['changeLevel'],
  setup(props, context) {
    const appStore = useApplicationStore();
    const lytStore = useLayoutStore();

    const dropdownVisibility = ref(false);

    const thisBuilding = computed(() => {
      return lytStore.buildings[props.buildingId];
    });

    const canChangeLevel = computed(() => {
      return BuildingType.CITY_HALL !== thisBuilding.value.type && appStore.editable;
    });

    return {
      building: thisBuilding,
      
      dropdownVisibility,
      canChangeLevel,

      levelList: computed(() => {
        const result = [];
        const maxLevel = BuildingLevel.calculateMaxLevel(thisBuilding.value.template, appStore.selectedEra);
        const increment = thisBuilding.value.isLuxurious && isHomeOrFarm(thisBuilding.value.type) ? 3 : 1;
        for (let i = thisBuilding.value.minLevel; i <= maxLevel; i += increment) {
          result.push('Level ' + i);
        }
        return result;
      }),
      maxLevel: computed(() => {
        return BuildingLevel.calculateMaxLevel(thisBuilding.value.template, appStore.selectedEra);
      }),

      toggleLevelSelector() {
        if (canChangeLevel.value) {
          dropdownVisibility.value = !dropdownVisibility.value;
        }
      },
      hideLevelSelector() {
        dropdownVisibility.value = false;
      },
      changeLevel(newLevel) {
        const level = parseInt(newLevel.toString().replace('Level ', ''));
        if (level !== thisBuilding.value.level) {
          context.emit('changeLevel', level);
        }
      }
    };
  }
};
</script>
